import Icon from './Icon';
import {
    faPlus as add,
    faCheck as checkmark,
    faTimes as close
} from '@fortawesome/free-solid-svg-icons';
import { useState, useRef, useEffect, useCallback } from "react";
import { InputGroup, Form, Button } from "react-bootstrap";
import { emptyChecklistItem } from "../state/reducer";
import { Task } from "../state/Task";
import { useData } from "../storage/accessors";

const ChecklistInput: React.FC<{ task: Task, newNumber: number }> = ({ task, newNumber }) => {
    const { checklistItems } = useData();
    const [editor, setEditor] = useState(false);
    const ref = useRef<HTMLInputElement>(null);
    useEffect(() => {
        if (editor && ref.current) {
            ref.current.focus();
        }
    }, [editor]);

    const inputKeyDown = useCallback((e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            checklistItems.create({ ...emptyChecklistItem(task.uuid), title: ref.current?.value || "", order: newNumber });
            //console.log(`create cl item with number ${newNumber}`);
            if (ref.current) {
                ref.current.value = ''
            }
        }
        if (e.key === "Escape") {
            setEditor(false);

        }
    }, [task.uuid, newNumber, checklistItems.objects]);

    return editor ?
        <InputGroup size="sm">
            <Form.Control type="text" ref={ref} onKeyDown={inputKeyDown} />
            <Button size="sm" variant="outline-success" onClick={() => {
                checklistItems.create({ ...emptyChecklistItem(task.uuid), title: ref.current?.value || "", order: newNumber })
                setEditor(false);
            }}><Icon icon={checkmark} /></Button>
            <Button size="sm" variant="outline-secondary" onClick={() => setEditor(false)}><Icon icon={close} /></Button>
        </InputGroup> : <Button size="sm" variant="outline-success" onClick={() => setEditor(true)}><Icon icon={add} /></Button>
}

export default ChecklistInput;
